import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToolsControlService {
  public active: boolean;
  navigationOnTop : boolean = false;

  constructor() { }
}
